import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const AdminContainer = styled(Box)(({ theme }) => ({
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between',
    flex: 1, 
    minWidth: 0
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
}));
